import { defineMessages } from 'react-intl';

export default defineMessages({
    select: {
        id: 'agency.admin.views.messages.select',
        defaultMessage: 'Select'
    }
});